import en from './languages/en.json';
import hr from './languages/hr.json';

export default { en, hr };
